import { computed } from 'vue';
import { useComponentI18n } from '@rdrive/i18n';
import messages from './messages/index.js';

// The spark row's three series (opt-in `sparklines`); a missing one renders as no data.
const SPARK_KEYS = ['totalItems', 'totalAssignedToYourTeams', 'totalAssignedToYou'];
const NO_SPARK = { data: [], labels: [], percentageChange: null };

// The emit the template calls inline, the local `t` and the spark row's normalised series; every
// card is a pure pass-through.
export default (props, { emit }) => {
  // LOCAL composer with the warn flags off — see @rdrive/i18n for why the flags are
  // assigned rather than passed. `totalOpenItemsToolTip` is deliberately NOT in
  // ./messages (see the barrel): it falls through to the root composer and misses there too.
  const { t } = useComponentI18n(messages);

  // Only the spark row reads it (the v-else row never does).
  const spark = computed(() => Object.fromEntries(
    SPARK_KEYS.map((key) => [key, { ...NO_SPARK, ...props.sparklines?.[key] }]),
  ));

  return { t, emit, spark };
};
